import React, { useState } from "react";
import { Form } from "antd";
import { Icon } from "@iconify/react";
import TextArea from "antd/es/input/TextArea";
import toast from "@comps/toast";
import { getErrorProps, makeRequest } from "@utils/helpers";
import { ButtonComponent, CancelButton, ModalComponent } from "@comps/components";
import { abendUserCasReq } from "../requests";

const formName = "amendForm";

/**
 * Abandoning a case a technician has taken, with the reason why.
 *
 * Wears the same shell as every other confirmation in the app (see
 * BaseConfirm) — an icon chip in the tone of the action, a title that
 * asks the question, and a commit button that repeats the verb. It is a
 * dialog rather than a plain confirm because this one needs a reason,
 * and the reason is what the other side reads.
 */
const AmendCaseComponent = (props) => {
  const [errors, setErrors] = useState([]);
  const [loader, setLoader] = useState(false);

  const rules = {
    reason: [{ required: true, message: "Say why the case is being abandoned" }],
  };

  const onFinish = (data) => {
    makeRequest(setLoader, abendUserCasReq, {
      id: props.caseid,
      reason: data.reason,
    }, onSuccess, onError);
  };

  const onSuccess = () => props.onSuccess();

  const onError = (data, res) => {
    setErrors(Array.isArray(data) ? { reason: data } : []);
    toast.error((res && res.msg) || "Unable to abandon this case");
  };

  const footer = (
    <div className="form-actions">
      <CancelButton key="close_button" onClick={ () => props.handleCancel(false) } text="Keep working on it" />
      <ButtonComponent
        key="create_button"
        form={ formName }
        htmlType="submit"
        type="primary"
        danger
        state={ loader }
      >
        Abandon case
      </ButtonComponent>
    </div>
  );

  return (
    <ModalComponent
      className="base-modal confirm-modal confirm-modal--danger"
      icon="tabler:arrow-back-up"
      mainTitle="Abandon this case?"
      subTitle="It leaves your queue and someone else picks it up"
      open={ true }
      onCancel={ props.handleCancel }
      width="min(560px, calc(100vw - 32px))"
      footer={ footer }
    >
      <Form layout="vertical" name={ formName } onFinish={ onFinish }>
        <Form.Item
          name="reason"
          rules={ rules.reason }
          label="Why are you abandoning it?"
          className="da-mb-16"
          onChange={ () => setErrors([]) }
          { ...getErrorProps(errors['reason']) }
        >
          <TextArea rows={ 4 } placeholder="e.g. Scan will not open, needs re-uploading" />
        </Form.Item>
      </Form>

      <p className="confirm-outcome">
        <Icon icon="tabler:arrow-narrow-right" width={ 17 } />
        <span>The case returns to New Cases, unassigned, and can be taken by anyone.</span>
      </p>
    </ModalComponent>
  );
};

export default AmendCaseComponent;
